import React from 'react';
import { 
  FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, 
  FaWhatsapp, FaFacebook, FaInstagram, FaLinkedin
} from 'react-icons/fa';
import './contact.css';
import { useScrollAnimation, useStaggeredAnimation } from '../../hooks/useScrollAnimation';
import { useApp } from '../../context/AppContext';

const Contact = () => {
  const { t } = useApp();
  
  // Scroll animations
  const heroRef = useScrollAnimation('fade-up');
  const infoCardsRefs = useStaggeredAnimation(4, 'scale-in', 100);
  const mapRef = useScrollAnimation('fade-left');

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <div className="contact-hero" ref={heroRef}>
        <div className="contact-hero-overlay"></div>
        <div className="contact-hero-content">
          <h1>{t.contactPage.hero.title}</h1>
          <p>{t.contactPage.hero.subtitle}</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="contact-container">
        {/* Contact Info Cards */}
        <div className="contact-info-grid">
          <div className="contact-info-card" ref={el => infoCardsRefs.current[0] = el}>
            <div className="contact-icon-wrapper contact-icon-phone">
              <FaPhone />
            </div>
            <h3>{t.contactPage.cards.phone.title}</h3>
            <p>{t.contactPage.cards.phone.schedule}</p>
            <a href="tel:+40743131559">+40 743 131 559</a>
            <a href="tel:+40751268586">+40 751 268 586</a>
          </div>

          <div className="contact-info-card" ref={el => infoCardsRefs.current[1] = el}>
            <div className="contact-icon-wrapper contact-icon-email">
              <FaEnvelope />
            </div>
            <h3>{t.contactPage.cards.email.title}</h3>
            <p>{t.contactPage.cards.email.response}</p>
            <a href="mailto:office@terasamente.com">office@terasamente.com</a>
          </div>

          <div className="contact-info-card" ref={el => infoCardsRefs.current[2] = el}>
            <div className="contact-icon-wrapper contact-icon-location">
              <FaMapMarkerAlt />
            </div>
            <h3>{t.contactPage.cards.location.title}</h3>
            <p>{t.contactPage.cards.location.area}</p>
            <address>
              Loc. Luna, Nr. 836<br />
              Jud. Cluj, Romania
            </address>
          </div>

          <div className="contact-info-card" ref={el => infoCardsRefs.current[3] = el}>
            <div className="contact-icon-wrapper contact-icon-hours">
              <FaClock />
            </div>
            <h3>{t.contactPage.cards.hours.title}</h3>
            <p><strong>{t.contactPage.cards.hours.weekdays}:</strong> 8:00 - 18:00</p>
            <p><strong>{t.contactPage.cards.hours.saturday}:</strong> 9:00 - 14:00</p>
            <p><strong>{t.contactPage.cards.hours.sunday}:</strong> {t.contactPage.cards.hours.closed}</p>
          </div>
        </div>

        {/* Map and Additional Info Section */}
        <div className="contact-content">
          <div className="contact-map-section" ref={mapRef}>
            <div className="contact-section-header">
              <h2>{t.contactPage.map.title}</h2>
              <p>{t.contactPage.map.subtitle}</p>
            </div>

            <div className="contact-map-container">
              <iframe
                src="https://maps.google.com/maps?q=46.5154075,23.9161473&t=k&z=17&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="500"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Location Map"
              />
            </div>

            {/* Quick Contact Options */}
            <div className="contact-quick-contact">
              <h3>{t.contactPage.quickContact.title}</h3>
              <div className="contact-quick-contact-buttons">
                <a href="https://wa.me/40743131559" className="contact-quick-btn contact-whatsapp" target="_blank" rel="noopener noreferrer">
                  <FaWhatsapp />
                  <span>{t.contactPage.quickContact.whatsapp}</span>
                </a>
                <a href="tel:+40743131559" className="contact-quick-btn contact-phone-btn">
                  <FaPhone />
                  <span>{t.contactPage.quickContact.call}</span>
                </a>
                <a href="mailto:office@terasamente.com" className="contact-quick-btn contact-email-btn">
                  <FaEnvelope />
                  <span>{t.contactPage.quickContact.email}</span>
                </a>
              </div>
            </div>

            {/* Social Media */}
            <div className="contact-social-section">
              <h3>{t.contactPage.social.title}</h3>
              <div className="contact-social-links">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="contact-social-link contact-facebook">
                  <FaFacebook />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="contact-social-link contact-instagram">
                  <FaInstagram />
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="contact-social-link contact-linkedin">
                  <FaLinkedin />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;